// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"949":"ee9f642d1afaa68d","1834":"41bcb83529446b44","6144":"755f9161a14d3bac"}[chunkId] + ".js";
};